import { useQuery } from "@tanstack/react-query";
import { Role } from "@/model/Member";
import roleRepository from "@/repository/roleRepository";


const getData = async (scenarioId: string) => {
    const res = await roleRepository.find(scenarioId);
    return res.data?.data;
};

export const useRole = (scenarioId: string) => {
    return useQuery<Role[]>({
        queryKey: ['role', 'scenario', scenarioId],
        queryFn: async () => getData(scenarioId),
        retry: false
    });
};
